import React, { Component } from 'react'
import Card from './Card'
import injectSheet from 'react-jss'
import { Link, withRouter } from 'react-router-dom'
import { connect } from 'react-redux'
import { formStyle } from '../../Theme/Theme'
// import * as Actions from '../../Actions/Actions'
import { apiUrl } from '../../Utility'
// import ReactGA from 'react-ga'

class PasswordReset extends Component {
  constructor(props) {
    super()
    this.state = {
        email: '',
        hasSubmitted: false,
        errorMsg: '',
        valid: false,
        password: '',
        confirmPassword: '',
        isReset: false,
    }
  }

  render() {
    // console.log(this.props.match.params.token)
    // const {classes} = this.props
    return (
        <Card>
            { this.renderForm() }
        </Card>
    )
  }

  componentDidMount () {
    // ReactGA.pageview('/welcome/ResetPassword/');
  }  

  renderForm () {
      const { classes } = this.props
      if (this.state.hasSubmitted === false) {
        return (
            <div>
                <div className={classes.Header}>
                    <h1>Reset Password</h1>
                    {this.state.errorMsg ? <span className={this.props.classes.ErrorText}><i className="fas fa-exclamation-triangle" style={{marginRight: '.5rem'}}/>{this.state.errorMsg}</span> : <span className={this.props.classes.ErrorText}/>}
                </div>    
                <div className={classes.Body}>
                    <input name="email" type="email" placeholder='Email' value={this.state.email} onChange={this.onChange}/>
                    <input type="password" name='password' placeholder='Password' value={this.state.password} onChange={this.onChange} />
                    <input type="password" name='confirmPassword' placeholder='Confirm Password' value={this.state.confirmPassword} onChange={this.onChange} />
                </div>
                <div className={classes.Footer}>
                <a className={this.state.valid ? this.props.classes.NextButton : this.props.classes.Disabled} onClick={this.resetPassword}>Reset Password</a>
                </div>            
            </div>
        )
      } else {
        if (this.state.isReset){
            return  this.renderSuccess()
        } else {
            return this.renderFail()
        }
      }
  }

  renderSuccess () {
    return (
        <div>
            <div className={this.props.classes.Header}>
                <h1>Success!</h1>
            </div>   
            <div style={{paddingTop: '0',paddingBottom: '1rem',paddingLeft: '1rem',paddingRight: '1rem'}} className={this.props.classes.Header}>
                Your password was reset.
            </div>
            <div className={this.props.classes.Footer}>
                <Link className={this.props.classes.NextButton} to='/welcome/signin'>sign in</Link>
            </div>
        </div>
    )
  }

  renderFail () {
    return (
        <div>
            <div className={this.props.classes.Header}>
                <h1>Sorry!</h1>
            </div>   
            <div style={{paddingTop: '0',paddingBottom: '1rem',paddingLeft: '1rem',paddingRight: '1rem'}} className={this.props.classes.Header}>
                We could not reset your <br/>password at this time.
            </div>
            <div className={this.props.classes.Footer}>
                <Link className={this.props.classes.NextButton} to='/welcome'>back</Link>
            </div>
        </div>
    )
  }

  onChange = e => {
    const name = e.target.name
    const value = e.target.value
    // let isValid

    let { email, password, confirmPassword } = this.state

    const newState = {
        [name]: value,
        errorMsg: '',
        valid: false
      }

     switch (name) {
        case 'email':
            email = value
            break
        case 'password':
            password = value
            break
        case 'confirmPassword':
            confirmPassword = value
            break
        default:
            break
    }

        const emailIsFilled = email.length > 0
        const passwordIsFilled = password.length > 0
        const confirmPasswordIsFilled = confirmPassword.length > 0

        const isFilled = emailIsFilled && passwordIsFilled && confirmPasswordIsFilled
        if (isFilled) {
            newState.errorMsg = ``
            newState.valid = true
            if ( !email.includes('@') || !email.includes('.') ) {
                newState.errorMsg = `Valid email is required`
                newState.valid = false
            }

            if (confirmPassword !== password) {
                newState.errorMsg = `Passwords don't match`
                newState.valid = false
            }
        }

        this.setState(newState)
    }

    resetPassword = () => {
        let email = this.state.email
        let password = this.state.password
        let token = this.props.match.params.token
        // console.log('test')
        const req = new Request(`https://${apiUrl}/api/v1/password_reset?email=${encodeURIComponent(email)}&password=${encodeURIComponent(password)}&token=${encodeURIComponent(token)}`, {
          method: 'POST',
          headers: new Headers({
            'Content-Type': 'application/json'
          })
        })
        fetch(req)
          .then( response => {
            response.json().then(data => {
                console.log(data)
                if (data.message === 'Password successfully reset!'){
                    this.setState({isReset: true, hasSubmitted: true})
                } else {
                    this.setState({isReset: false, hasSubmitted: true})
                }
            })
          })
        
      }
}

export default withRouter(connect()(injectSheet(formStyle)(PasswordReset)))



// WEBPACK FOOTER //
// ./src/js/Components/LandingPage/ResetPassword.jsx